<template>
  <div class="tab-lesson-line-list-component custom-scrollbar pt-4">
    <div class="line-list-items flex-fill custom-scrollbar">
      <router-link
        v-for="(item, i) in items"
        :key="`item-${item.id}`"
        class="list-item text-decoration-none"
        :to="getRoute(item)"
      >
        <div class="d-flex flex-column align-items-center mr-3">
          <div
            class="circle"
            :class="{ fill: isCurrent(item), finished: isFinished(item) }"
          >
            <i
              v-if="isFinished(item) && !isCurrent(item)"
              class="icon-check border-0"
            ></i>
          </div>
          <div v-if="i < items.length - 1" class="line"></div>
        </div>
        <i v-if="isQuiz(item)" class="fa fa-file-pen mr-1"></i>
        <p :class="{ current: isCurrent(item) }">
          {{ getTitle(item) }}
        </p>
      </router-link>
    </div>
  </div>
</template>
<script>
import get from "lodash/get";
export default {
  props: {
    items: {
      type: Array,
      default: () => []
    },
    current: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    isQuiz(item) {
      return [
        "approval_average",
        "time_limit_minutes",
        "number_of_attempts"
      ].reduce((acc, cur) => acc && Object.keys(item).includes(cur), true);
    },
    getTitle(item) {
      if (this.isQuiz(item)) return item.title;
      return item.name;
    },
    isCurrent(item) {
      return this.current.id === item.id;
    },
    isFinished(item) {
      return get(item, "progress.finished_at", false);
    },
    getRoute(item) {
      if (this.isQuiz(item)) {
        return {
          name: "lesson-quiz",
          params: { id: item.module, quiz: item.code }
        };
      }
      return {
        name: "lesson",
        params: { id: item.module.id, lesson: item.id }
      };
    }
  }
};
</script>
<style lang="scss" scoped>
.tab-lesson-line-list-component {
  display: flex;
  flex-direction: column;
  height: -webkit-fill-available;

  .line-list-items {
    overflow-y: scroll;
    height: 400px;
    @media screen and (max-width: 991px) {
      height: 300px;
    }
  }
  .list-item {
    position: relative;
    display: flex;
    font-size: 14px;
    min-height: 60px;
    &:hover {
      opacity: 0.8;
    }
    .circle {
      flex-shrink: 0;
      height: 24px;
      width: 24px;
      border-radius: 50%;
      border: 1px solid #6b3ead;

      &.fill,
      &.finished {
        background-color: #6b3ead;
      }

      &.finished {
        position: relative;
        .icon-check {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          color: #fff;
          font-size: 20px;
        }
      }
    }
    i {
      line-height: 1.5;
    }

    .line {
      width: 2px;
      height: 100%;
    }
  }
}
</style>
